<template>
  <div
    :id="id"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"
  ></div>
</template>

<script>
import { judgmentUnit } from "@/assets/js/utils";
export default {
  props: ["id", "chartsData"],
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },

  methods: {
    drawLine() {
      let data = JSON.parse(JSON.stringify(this.chartsData));
      let unit = "kw·h";
      if (judgmentUnit(data, "value", 10000)) {
        unit = "万 kw·h";
        data.map((v) => {
          v.value = (v.value / 10000).toFixed(2);
        });
      }
      if (document.getElementById(this.id) == null) {
        return;
      }
      let myChart = this.$echarts.getInstanceByDom(
        document.getElementById(this.id)
      );
      if (!myChart) {
        myChart = this.$echarts.init(document.getElementById(this.id));
      }
      myChart.setOption({}, true);
      let option = {
        title: {
          // text: "{val|" + "}\n{name|TOTAL}",
          top: "center",
          left: "center",
          textStyle: {
            rich: {
              val: {
                fontSize: 16,
                fontWeight: "bold",
                color: "#fff",
              },
              name: {
                fontSize: 12,
                fontWeight: "normal",
                color: "#16E9F4",
                // padding: [10, 0],
              },
            },
          },
        },
        color: [
          "#31E9E5",
          "#6569FF ",
          "#309DF6",
          "#C2D8C2",
          "#048590",
          "#8CA4D7",
          "#8DAC88",
          "#BCB085",
          "#A68CD7",
          "#B49590",
        ],
        tooltip: {
          trigger: "item",
          // formatter: `{b}: {c}${unit} ({d}%)`,
          formatter: function (param) {
            return `${param.name}:${param.value}${unit}(${
              param.percent < 0.01 ? 0.01 : param.percent
            }%)`;
          },
        },
        series: [
          {
            type: "pie",
            radius: ["70%", "70%"],
            minAngle: 90,
            label: {
              show: false,
            },
            data: data,
          },
          {
            name: "",
            type: "pie",
            minAngle: 10, // label最小扇区大小
            label: {
              alignTo: "edge", // label两端对称布局
              edgeDistance: 10, // 布局为两端对称时候需要外边距防止图表变形 数值随意不要太大
              distanceToLabelLine: 0, // label距离引导线距离
              formatter: function (param) {
                return (
                  "{a|" +
                  (param.percent == undefined || param.percent < 0.01
                    ? 0.01
                    : param.percent) +
                  "%" +
                  "}\n{hr|}\n" +
                  "{d|" +
                  param.name +
                  "}"
                );
              },
              rich: {
                a: {
                  padding: [4, 10, 0, 10],
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: "bold",
                },
                d: {
                  padding: [0, 10, 4, 10],
                  color: "#A1A7B8",
                },
              },
            },
            labelLine: {
              lineStyle: {
                color: "#A1A7B8",
              },
            },
            radius: ["30%", "50%"],
            data: data,
          },
        ],
      };
      myChart.setOption(option);
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="scss"></style>
